import { Component } from '@angular/core';
import { BookingPassengerInfo, CabinClassList, GroupTicketDetailsProperties, GroupTicketProperties, GroupTicketSearchParameters, GroupTicketSegmentsProperties, PassengerTypeList, RBDTypeList, SegmentTypeList, TicketCurrencyProperties, TicketResponseMessage, TicketSuppliersAccessCodeProperties, TicketSuppliersProperties } from '../Models/GroupTicketProperties';
import { FlightSearchAirlineCodes, FlightSearchAirports, FlightSearchBaseData } from '../Models/FlightSearchProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { Observable, of } from 'rxjs';
import { NgForm, FormsModule } from '@angular/forms';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { AirlineMasterService } from '../Services/airline-master.service';
import { GroupTicketService } from '../Services/groupTicket.service';
import { GroupTitleService } from "../Services/group-title.service";
import { error } from 'console';
import { GroupTitleProperties } from '../Models/GroupTitleProperties';
import { Router } from '@angular/router';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoScrollingModule, DxoPagingModule, DxoPagerModule, DxoFilterRowModule, DxiColumnModule, DxoSearchPanelModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { NgClass, DatePipe } from '@angular/common';
import { AutoComplete } from 'primeng/autocomplete';
import { PrimeTemplate } from 'primeng/api';
import { DatePicker } from 'primeng/datepicker';
import { MultiSelect } from 'primeng/multiselect';


@Component({
    selector: 'app-group-ticket',
    templateUrl: './groupTicket.component.html',
    styleUrls: ['./groupTicket.component.css'],
    imports: [NavMenuComponent, DxDataGridModule, DxoScrollingModule, DxoPagingModule, DxoPagerModule, DxoFilterRowModule, DxiColumnModule, DxoSearchPanelModule, DxTemplateModule, Bind, Dialog, FormsModule, Select, NgClass, AutoComplete, PrimeTemplate, DatePicker, MultiSelect, DatePipe]
})

export class GroupTicketComponent {
  oneWayTicketSections: boolean = false;
  returnTicketSections: boolean = false;
  showAddTicketSections: boolean = true;
  showSegmentDetailsSection: boolean = false;
  showPassengerDetailsSection: boolean = false;
  showTicketDetailsSection1: boolean = false;
  showTicketDetailsSection2: boolean = false;
  segmentSubmitted: boolean = false;
  passengerSubmitted: boolean = false;
  ticketSubmittedSection1: boolean = false;
  ticketSubmittedSection2: boolean = false;
  ticketTitle: string = "";
  minDateRange: Date | undefined;
  groupTicketSearch = new GroupTicketSearchParameters();
  groupTicketProperties = new GroupTicketProperties();
  groupTicketDepartureSegmentsProperties: GroupTicketSegmentsProperties[] = [];
  groupTicketReturnSegmentsProperties: GroupTicketSegmentsProperties[] = [];
  segmentTypeList: SegmentTypeList[] | undefined;
  passengerTypeList: PassengerTypeList[] | undefined;
  airportList: FlightSearchAirports[] = [];
  filteredAirportsOW: string[] = [];
  airLineData: FlightSearchAirlineCodes[] = [];
  airlineMasterinfo: AirlineMasterProperties[] | undefined;
  groupTicketDetailsProperties: GroupTicketDetailsProperties[] = [];
  groupTicketList: GroupTicketProperties[] | undefined;
  disabledField: boolean = true;
  loaderVar: boolean = false;
  buttonDisabled: boolean = false;
  submitButtonText: string = "Save";
  currentDate: any;
  rbdTypeList: RBDTypeList[] | undefined;
  cabinClassList: CabinClassList[] | undefined;
  ticketCurrencyList: TicketCurrencyProperties[] | undefined;
  ticketSupplierList: TicketSuppliersProperties[] | undefined;
  ticketSupplierAccessCodeList: TicketSuppliersAccessCodeProperties[] | undefined;
  numberTicketsTotal: number = 0;
  ticketTitleHead: string;
  accessCodeDisabled: boolean = true;

  // //10-June-24
  // totalTickets: number = 0;
  // soldTickets: number = 0;
  // heldTickets: number = 0;
  // cancelledTickets: number = 0;
  // //end


  groupTitlesList: GroupTitleProperties[] = [];
  
  
  constructor(private flightService: FlightSearchService, private airlineservice: AirlineMasterService
    , private ticketService: GroupTicketService, private gruopTitleService: GroupTitleService, public router: Router) {

  }
  ngOnInit(): void {
    this.ticketTitleHead = "Click To Add Ticket";
    this.minDateRange = new Date();
    // this.minDateRange.setDate(this.minDateRange.getDate() + 0);
    this.segmentTypeList = [
      { segmentTypeId: 1, segmentTypeName: "OneWay" }, { segmentTypeId: 2, segmentTypeName: "Return" }
    ];
    this.passengerTypeList = [
      { passengerTypeId: 1, passengerTypeName: "Adult" }, { passengerTypeId: 2, passengerTypeName: "Child" },
      { passengerTypeId: 3, passengerTypeName: "Infant" }
    ];
    this.rbdTypeList = [
      { rbdType: "A" }, { rbdType: "B" }, { rbdType: "C" }, { rbdType: "D" }, { rbdType: "E" }, { rbdType: "F" },
      { rbdType: "G" }, { rbdType: "H" }, { rbdType: "I" }, { rbdType: "J" }, { rbdType: "K" }, { rbdType: "L" },
      { rbdType: "M" }, { rbdType: "N" }, { rbdType: "O" }, { rbdType: "P" }, { rbdType: "Q" }, { rbdType: "R" },
      { rbdType: "S" }, { rbdType: "T" }, { rbdType: "U" }, { rbdType: "V" }, { rbdType: "W" }, { rbdType: "X" },
      { rbdType: "Y" }, { rbdType: "Z" }, { rbdType: "All" },

    ];
    this.cabinClassList = [
      { cabinType: "FirstClass" }, { cabinType: "Business" }, { cabinType: "Economy" }, { cabinType: "PremiumEconomy" },
    ];
    this.GetSearchBaseData();
    this.GetAirlineData();
    this.GetAllGroupTicket();
    this.CurrentDate();
    this.GetAllGroupTitles();
  }
  CurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;

  }
  GetSearchBaseData = (): void => {
    try {
      this.flightService.GetFlightBaseData().subscribe((data) => {
        this.airLineData = data.airlines;
        this.airportList = data.airports;

      });
      this.ticketService.GetTicketBaseData().subscribe((data) => {
        this.ticketCurrencyList = data.ticketCurrencyProperties;
        this.ticketSupplierList = data.ticketSuppliersProperties;
      });

    }
    catch (e) {
      console.log(e)
    }
  }
  GetAllGroupTitles = (): void => {
    this.gruopTitleService.GetAllGroupTitle().subscribe((data) => {
      //console.log(data);
      this.groupTitlesList = data;
    });
  };
  GetSupplierAccessCodes = (supplierId: string): void => {
    try {
      this.ticketService.GetTicketAccessCode(supplierId).subscribe(data => {
        this.ticketSupplierAccessCodeList = data;
        this.accessCodeDisabled = false;
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }
  GetSupplierAccessCodesCurrency=(officeId:string):void=>{
    const accessCode= this.ticketSupplierAccessCodeList.find(a=>a.officeId===officeId);
    if(accessCode){
      this.groupTicketProperties.ticketCurrency=accessCode.currencyName;
    }
  }
  filterAirportsOW = (event: any): void => {
    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }
  GetAirlineData = (): void => {
    try {
      this.airlineservice.getAirlinesData().subscribe((data) => {
        if (data.length > 0) {
          this.airlineMasterinfo = data;
        }
      })
    }
    catch (e) {
      console.log(e);
    }
  }
  GetAllGroupTicket = (): void => {
    this.ticketService.GetAllGroupTicketList(this.groupTicketSearch).subscribe(response => {
      if (response.status == true) {
        //10-June-24
        // this.totalTickets = response.totalTickets;
        // this.soldTickets = response.soldTickets;
        // this.heldTickets = response.heldTickets;
        // this.cancelledTickets = response.cancelledTickets;
        //end

        this.groupTicketList = response.responseData.map(tkt => {

          return { ...tkt, tripRoute: tkt.onewayFromAirport + "--" + tkt.onewayToAirport }
        });
      }

    }, (error) => {
      console.log(error);
      // document.getElementById("responseMeaasge").innerHTML =error;
      // document.getElementById("responseMeaasge").style.color ="red";
      // setTimeout(() => {
      //     document.getElementById("responseMeaasge").innerHTML = "";
      //     document.getElementById("responseMeaasge").style.color ="";
      // }, 5000);

    });
  }
  AddOneWayTicket = (): void => {
    this.ticketTitle = "Ticket Detail - One Way";
    this.submitButtonText = "Save"
    this.showTicketDetailsSection1 = true
    this.oneWayTicketSections = true;
    this.showAddTicketSections = false;
    this.groupTicketDepartureSegmentsProperties = [];
    this.groupTicketDetailsProperties = [];
    this.groupTicketProperties = new GroupTicketProperties();
    this.groupTicketProperties.tripType = "OneWay";
    let groupTicketDepartSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketDepartSegmentsProperties.segmentType = 1;
    groupTicketDepartSegmentsProperties.departureSegment = true;
    this.groupTicketDepartureSegmentsProperties.push(groupTicketDepartSegmentsProperties);

  }
  AddReturnTicket = (): void => {
    this.ticketTitle = "Ticket Detail - Return";
    this.submitButtonText = "Save"
    this.showTicketDetailsSection1 = true
    this.oneWayTicketSections = true;
    this.returnTicketSections = true;
    this.showAddTicketSections = false;
    this.groupTicketDepartureSegmentsProperties = [];
    this.groupTicketDetailsProperties = [];
    this.groupTicketProperties = new GroupTicketProperties();
    this.groupTicketProperties.tripType = "Return";
    let groupTicketDepartSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketDepartSegmentsProperties.segmentType = 2;
    groupTicketDepartSegmentsProperties.departureSegment = true;
    this.groupTicketDepartureSegmentsProperties.push(groupTicketDepartSegmentsProperties);
    this.groupTicketReturnSegmentsProperties = [];
    let groupTicketReturnSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketReturnSegmentsProperties.segmentType = 2;
    groupTicketReturnSegmentsProperties.returnSegment = true;
    this.groupTicketReturnSegmentsProperties.push(groupTicketReturnSegmentsProperties);
  }
  CloseTicketSection = (): void => {
    this.ticketTitle = "";
    this.showSegmentDetailsSection = false;
    this.showPassengerDetailsSection = false;
    this.showTicketDetailsSection1 = false;
    this.showTicketDetailsSection2 = false;
    this.segmentSubmitted = false;
    this.passengerSubmitted = false;
    this.ticketSubmittedSection1 = false;
    this.ticketSubmittedSection2 = false;
    this.showAddTicketSections = true;
    this.oneWayTicketSections = false;
    this.returnTicketSections = false;
    this.groupTicketDepartureSegmentsProperties = [];
    this.groupTicketReturnSegmentsProperties = [];
    this.groupTicketDetailsProperties = [];
    this.groupTicketProperties = new GroupTicketProperties();
    this.numberTicketsTotal = 0;
    this.accessCodeDisabled = true;
  }
  AddNewDepartueSegment = (): void => {
    let groupTicketDepartSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketDepartSegmentsProperties.segmentType = 1;
    groupTicketDepartSegmentsProperties.departureSegment = true;
    this.groupTicketDepartureSegmentsProperties.push(groupTicketDepartSegmentsProperties);
  }
  AddNewDepartueReturnSegment = (): void => {
    let groupTicketDepartSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketDepartSegmentsProperties.segmentType = 2;
    groupTicketDepartSegmentsProperties.departureSegment = true;
    this.groupTicketDepartureSegmentsProperties.push(groupTicketDepartSegmentsProperties);
  }
  AddNewReturnSegment = (): void => {
    let groupTicketReturnSegmentsProperties = new GroupTicketSegmentsProperties();
    groupTicketReturnSegmentsProperties.segmentType = 2;
    groupTicketReturnSegmentsProperties.returnSegment = true;
    this.groupTicketReturnSegmentsProperties.push(groupTicketReturnSegmentsProperties);
  }
  RemoveDepartureSegmentInformation = (index: number): void => {

    if (this.groupTicketDepartureSegmentsProperties.length > 1) {
      if (this.groupTicketDepartureSegmentsProperties[index].segmentId != 0) {
        this.ticketService.DeleteSegment(this.groupTicketDepartureSegmentsProperties[index].segmentId).subscribe((response) => {
          if (response.status == true) {
            document.getElementById(`InformationTitle${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitle${index}`).style.color = "#2BA744";
            setTimeout(() => {
              this.groupTicketDepartureSegmentsProperties[index].segmentType = 0;
              this.groupTicketDepartureSegmentsProperties[index].departureSegment = false;
              this.groupTicketDepartureSegmentsProperties.splice(index, 1);
            }, 4000)

          }
          else {
            document.getElementById(`InformationTitle${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitle${index}`).style.color = "#f44336";
            setTimeout(() => {
              document.getElementById(`InformationTitle${index}`).innerHTML = "Segment Information: <b>1</b>";
              document.getElementById(`InformationTitle${index}`).style.color = "";
            }, 4000)

          }
        }, (error) => {
          document.getElementById(`InformationTitle${index}`).innerHTML = error;
          document.getElementById(`InformationTitle${index}`).style.color = "#f44336";
          setTimeout(() => {
            document.getElementById(`InformationTitle${index}`).innerHTML = "Segment Information: <b>1</b>";
            document.getElementById(`InformationTitle${index}`).style.color = "";
          }, 5000)
        });
      }
      else {
        this.groupTicketDepartureSegmentsProperties[index].segmentType = 0;
        this.groupTicketDepartureSegmentsProperties[index].departureSegment = false;
        this.groupTicketDepartureSegmentsProperties.splice(index, 1);
      }

    }
    else {
      document.getElementById(`InformationTitle${0}`).innerHTML = "Not Allowed to Remove All Segment!";
      document.getElementById(`InformationTitle${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitle${0}`).innerHTML = "Segment Information: <b>1</b>";
        document.getElementById(`InformationTitle${0}`).style.color = "";
      }, 4000)
    }
  }
  RemoveReturnSegmentInformation = (index: number): void => {

    if (this.groupTicketReturnSegmentsProperties.length > 1) {
      if (this.groupTicketReturnSegmentsProperties[index].segmentId != 0) {
        this.ticketService.DeleteSegment(this.groupTicketReturnSegmentsProperties[index].segmentId).subscribe((response) => {
          if (response.status == true) {
            document.getElementById(`InformationTitleReturn${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitleReturn${index}`).style.color = "#2BA744";
            setTimeout(() => {
              this.groupTicketReturnSegmentsProperties[index].segmentType = 0;
              this.groupTicketReturnSegmentsProperties[index].departureSegment = false;
              this.groupTicketReturnSegmentsProperties.splice(index, 1);
            }, 4000)

          }
          else {
            document.getElementById(`InformationTitleReturn${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitleReturn${index}`).style.color = "#f44336";
            setTimeout(() => {
              document.getElementById(`InformationTitleReturn${index}`).innerHTML = "Segment Information: <b>1</b>";
              document.getElementById(`InformationTitleReturn${index}`).style.color = "";
            }, 4000)

          }
        }, (error) => {
          document.getElementById(`InformationTitleReturn${index}`).innerHTML = error;
          document.getElementById(`InformationTitleReturn${index}`).style.color = "#f44336";
          setTimeout(() => {
            document.getElementById(`InformationTitleReturn${index}`).innerHTML = "Segment Information: <b>1</b>";
            document.getElementById(`InformationTitleReturn${index}`).style.color = "";
          }, 5000)
        });
      }
      else {
        this.groupTicketReturnSegmentsProperties[index].segmentType = 0;
        this.groupTicketReturnSegmentsProperties[index].departureSegment = false;
        this.groupTicketReturnSegmentsProperties.splice(index, 1);
      }
    }
    else {
      document.getElementById(`InformationTitleReturn${0}`).innerHTML = "Not Allowed to Remove All Segment!";
      document.getElementById(`InformationTitleReturn${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitleReturn${0}`).innerHTML = "Segment Information: <b>1</b>";
        document.getElementById(`InformationTitleReturn${0}`).style.color = "";
      }, 4000)
    }
  }
  OneWayDepartureFromTicket = (fromAirport: string): void => {
    this.groupTicketProperties.onewayFromAirport = fromAirport.split("-")[0].trim();
    if (this.returnTicketSections == true) {
      this.groupTicketProperties.returnToAirport = this.groupTicketProperties.onewayFromAirport;
    }
    else {
      this.groupTicketProperties.returnToAirport = "";
    }
  }
  OneWayDepartureToTicket = (toAirport: string): void => {
    this.groupTicketProperties.onewayToAirport = toAirport.split("-")[0].trim();
    if (this.returnTicketSections == true) {
      this.groupTicketProperties.returnFromAirport = this.groupTicketProperties.onewayToAirport;
    }
    else {
      this.groupTicketProperties.returnFromAirport = "";
    }
  }
  ReturnDepartureFromTicket = (fromAirport: string): void => {
    this.groupTicketProperties.returnFromAirport = fromAirport.split("-")[0].trim();
  }
  ReturnDepartureToTicket = (toAirport: string): void => {
    this.groupTicketProperties.returnToAirport = toAirport.split("-")[0].trim();
  }
  OneWayDepartureFrom = (fromAirport: string, index: number): void => {
    this.groupTicketDepartureSegmentsProperties[index].fromAirport = fromAirport.split("-")[0].trim();
    this.groupTicketDepartureSegmentsProperties[index].fromCityName = fromAirport.split("-")[1].trim();
    this.groupTicketDepartureSegmentsProperties[index].fromAirportName = fromAirport.split("-")[2].trim();
  }
  OneWayArrivalTo = (toAirport: string, index: number): void => {
    this.groupTicketDepartureSegmentsProperties[index].toAirport = toAirport.split("-")[0].trim();
    this.groupTicketDepartureSegmentsProperties[index].toCityName = toAirport.split("-")[1].trim();
    this.groupTicketDepartureSegmentsProperties[index].toAirportName = toAirport.split("-")[2].trim();
  }
  ReturnDepartureFrom = (fromAirport: string, index: number): void => {
    this.groupTicketReturnSegmentsProperties[index].fromAirport = fromAirport.split("-")[0].trim();
    this.groupTicketReturnSegmentsProperties[index].fromCityName = fromAirport.split("-")[1].trim();
    this.groupTicketReturnSegmentsProperties[index].fromAirportName = fromAirport.split("-")[2].trim();
  }
  ReturnArrivalTo = (toAirport: string, index: number): void => {
    this.groupTicketReturnSegmentsProperties[index].toAirport = toAirport.split("-")[0].trim();
    this.groupTicketReturnSegmentsProperties[index].toCityName = toAirport.split("-")[1].trim();
    this.groupTicketReturnSegmentsProperties[index].toAirportName = toAirport.split("-")[2].trim();
  }
  OneWayAirlineSelect = (airlineName: string, index: number): void => {
    const airlineFilter = this.airlineMasterinfo.find(airline => airline.airlineLegalName === airlineName);
    this.groupTicketDepartureSegmentsProperties[index].airlineLogo = airlineFilter.airlineLogo;
    this.groupTicketDepartureSegmentsProperties[index].airlineCombineCode = airlineFilter.airlineCombineCode;
  }
  ReturnAirlineSelect = (airlineName: string, index: number): void => {
    const airlineFilter = this.airlineMasterinfo.find(airline => airline.airlineLegalName === airlineName);
    this.groupTicketReturnSegmentsProperties[index].airlineLogo = airlineFilter.airlineLogo;
    this.groupTicketReturnSegmentsProperties[index].airlineCombineCode = airlineFilter.airlineCombineCode;
  }
  CapitalizedFareBasisCode = (fareBasisCode: string, index: number): void => {
    if (fareBasisCode != "" && fareBasisCode != undefined && fareBasisCode != null) {
      this.groupTicketDepartureSegmentsProperties[index].fareBasisCode = fareBasisCode.toUpperCase();
    }

  }
  CapitalizedReturnFareBasisCode = (fareBasisCode: string, index: number): void => {
    if (fareBasisCode != "" && fareBasisCode != undefined && fareBasisCode != null) {
      this.groupTicketReturnSegmentsProperties[index].fareBasisCode = fareBasisCode.toUpperCase();
    }
  }
  ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  DateValidationDepartureOneWay = (date: any, index: number): void => {
    if (date < this.currentDate) {
      this.groupTicketDepartureSegmentsProperties[index].departureDate = this.currentDate;
    }
  }
  DateValidationArivalOneWay = (date: any, index: number): void => {
    if (date < this.currentDate) {
      this.groupTicketDepartureSegmentsProperties[index].arrivalDate = this.currentDate;
    }
  }
  DateValidationDepartureReturn = (date: any, index: number): void => {
    if (date < this.currentDate) {
      this.groupTicketReturnSegmentsProperties[index].departureDate = this.currentDate;
    }
  }
  DateValidationArivalReturn = (date: any, index: number): void => {
    if (date < this.currentDate) {
      this.groupTicketReturnSegmentsProperties[index].arrivalDate = this.currentDate;
    }
  }
  //10-June-24
  DateValidationTicketExpiry = (date: any): void => {
    const expiryDate = new Date(date);
    const departureDate = new Date(this.groupTicketProperties.departureDate);

    // Ensure the expiry date is not earlier than the current date
    if (expiryDate < this.currentDate) {
      this.groupTicketProperties.ticketExpiryDate = this.currentDate;
    }
    // Ensure the expiry date is not after the departure date
    else if (expiryDate > departureDate) {
      this.groupTicketProperties.ticketExpiryDate = departureDate;
    } else {
      this.groupTicketProperties.ticketExpiryDate = expiryDate;
    }
  }

  DateValidationDepartureTicketDate = (date: any): void => {
    const departureDate = new Date(date);

    // Ensure the departure date is not earlier than the current date
    if (departureDate < this.currentDate) {
      this.groupTicketProperties.departureDate = this.currentDate;
    } else {
      this.groupTicketProperties.departureDate = departureDate;
    }

    // Ensure the expiry date is not before the current date
    if (this.groupTicketProperties.departureDate < this.groupTicketProperties.ticketExpiryDate) {
      //console.log("Warning: Expiry date is after the departure date.");
      //this.groupTicketProperties.ticketExpiryDate = this.currentDate;
      this.groupTicketProperties.ticketExpiryDate = this.groupTicketProperties.departureDate
    }
  }
  //end

  DateValidationRetunTicketDate = (date: any): void => {
    if (date < this.currentDate) {
      this.groupTicketProperties.returnDate = this.currentDate;
    }
  }
  SubmitTicketStart = (ticketDetailStart: any): boolean => {
    let ticketSection1Validation: boolean = false;
    this.ticketSubmittedSection1 = true;
    if (ticketDetailStart.invalid) {
      document.getElementById("errorTicketSection1").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorTicketSection1").innerHTML = "";
      }, 5000);
      return false;
    }
    else {


      if (this.groupTicketProperties.totalNumberTicket > 0 && this.groupTicketProperties.totalNumberTicket != null) {
        ticketSection1Validation = true;
      }
      else {
        ticketSection1Validation = false;
        document.getElementById("errorTicketSection1").innerHTML = "**Please Enter Required Filelds!";
        setTimeout(() => {
          document.getElementById("errorTicketSection1").innerHTML = "";
        }, 5000);
        return false;
      }
      if (this.groupTicketProperties.onewayFromAirport == this.groupTicketProperties.onewayToAirport) {
        ticketSection1Validation = false;
        document.getElementById("errorTicketSection1").innerHTML = "**Departure And Arrival Should Not Be Same!";
        setTimeout(() => {
          document.getElementById("errorTicketSection1").innerHTML = "";
        }, 5000);
        return false;
      }
      else {
        ticketSection1Validation = true;
      }
      if (this.submitButtonText == "Update") {
        if (this.groupTicketProperties.totalNumberTicket < this.groupTicketProperties.remainingTickets) {
          ticketSection1Validation = false;
          document.getElementById("errorTicketSection1").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById("errorTicketSection1").innerHTML = "";
          }, 5000);
          return false;
        }
        else {
          ticketSection1Validation = true;
        }
      }
      else {
        this.groupTicketProperties.remainingTickets = this.groupTicketProperties.totalNumberTicket;
        ticketSection1Validation = true;
      }
      if (ticketSection1Validation == true) {
        this.groupTicketDepartureSegmentsProperties[0].departureDate = this.groupTicketProperties.departureDate;
        if (this.returnTicketSections == true) {
          this.groupTicketReturnSegmentsProperties[0].departureDate = this.groupTicketProperties.returnDate;
        }
        this.showTicketDetailsSection1 = false;
        this.showSegmentDetailsSection = true;
      }
    }
  }
  SubmitSegment = (segmentForm: any): boolean => {
    let segementValidationSuccess: boolean = true;
    this.segmentSubmitted = true;
    if (segmentForm.invalid) {
      document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorSegmentSection").innerHTML = "";
      }, 5000);
      return false;
    }
    else {
      if (this.groupTicketProperties.onewayFromAirport != this.groupTicketDepartureSegmentsProperties[0].fromAirport) {
        segementValidationSuccess = false;
        document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
        setTimeout(() => {
          document.getElementById("errorSegmentSection").innerHTML = "";
        }, 5000);
        return false;
      }
      if (this.groupTicketProperties.onewayToAirport != this.groupTicketDepartureSegmentsProperties[this.groupTicketDepartureSegmentsProperties.length - 1].toAirport) {
        segementValidationSuccess = false;
        document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
        setTimeout(() => {
          document.getElementById("errorSegmentSection").innerHTML = "";
        }, 5000);
        return false;
      }
      if (this.returnTicketSections == true) {
        if (this.groupTicketProperties.returnFromAirport != this.groupTicketReturnSegmentsProperties[0].fromAirport) {
          segementValidationSuccess = false;
          document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById("errorSegmentSection").innerHTML = "";
          }, 5000);
          return false;
        }
        if (this.groupTicketProperties.returnToAirport != this.groupTicketReturnSegmentsProperties[this.groupTicketReturnSegmentsProperties.length - 1].toAirport) {
          segementValidationSuccess = false;
          document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById("errorSegmentSection").innerHTML = "";
          }, 5000);
          return false;
        }
      }
      if (segementValidationSuccess == true) {
        if (this.groupTicketDetailsProperties.length == 0) {
          let groupTicketDetailsProperties = new GroupTicketDetailsProperties();
          this.groupTicketDetailsProperties.push(groupTicketDetailsProperties);
        }
        this.showSegmentDetailsSection = false;
        this.showPassengerDetailsSection = true;
      }

      // if (this.groupTicketReturnSegmentsProperties.length > 0) {
      //     for (let rs = 0; rs < this.groupTicketReturnSegmentsProperties.length; rs++) {
      //         if ((this.groupTicketReturnSegmentsProperties[rs].seatCharges < 0 || this.groupTicketReturnSegmentsProperties[rs].seatCharges == null)) {
      //             this.groupTicketReturnSegmentsProperties[rs].seatCharges = 0;
      //         }
      //         if ((this.groupTicketReturnSegmentsProperties[rs].mealCharges < 0 || this.groupTicketReturnSegmentsProperties[rs].mealCharges == null)) {
      //             this.groupTicketReturnSegmentsProperties[rs].mealCharges = 0;

      //         }
      //         if ((this.groupTicketReturnSegmentsProperties[rs].baggageCharges < 0 || this.groupTicketReturnSegmentsProperties[rs].baggageCharges == null)) {
      //             this.groupTicketReturnSegmentsProperties[rs].baggageCharges = 0;

      //         }
      //         // if (this.groupTicketReturnSegmentsProperties[rs].baggageCheckIn != "" && this.groupTicketReturnSegmentsProperties[rs].baggageCheckIn != undefined && this.groupTicketReturnSegmentsProperties[rs].baggageCheckIn != null) {
      //         //     if ((this.groupTicketReturnSegmentsProperties[rs].baggageCharges <= 0)) {
      //         //         this.baggageChargesReturnValidation[rs] = true;
      //         //         setTimeout(() => {
      //         //             this.baggageChargesReturnValidation[rs] = false;
      //         //         }, 5000)
      //         //         segementValidationSuccess = false;
      //         //         return;
      //         //     }

      //         // }
      //         // else {
      //         //     this.groupTicketReturnSegmentsProperties[rs].baggageCharges = 0;
      //         //     this.baggageChargesReturnValidation[rs] = false;
      //         // }
      //     }
      // }
      // //   if (segementValidationSuccess == true) {
      // if (this.groupTicketDetailsProperties.length == 0) {
      //     let groupTicketDetailsProperties = new GroupTicketDetailsProperties();
      //     for (let d = 0; d < this.groupTicketDepartureSegmentsProperties.length; d++) {
      //         groupTicketDetailsProperties.totalMealCharges += this.groupTicketDepartureSegmentsProperties[d].mealCharges;
      //         groupTicketDetailsProperties.totalSeatCharges += this.groupTicketDepartureSegmentsProperties[d].seatCharges;
      //         groupTicketDetailsProperties.totalbaggageCharges += this.groupTicketDepartureSegmentsProperties[d].baggageCharges;
      //     }
      //     if (this.returnTicketSections == true) {
      //         for (let d = 0; d < this.groupTicketReturnSegmentsProperties.length; d++) {
      //             groupTicketDetailsProperties.totalMealCharges += this.groupTicketReturnSegmentsProperties[d].mealCharges;
      //             groupTicketDetailsProperties.totalSeatCharges += this.groupTicketReturnSegmentsProperties[d].seatCharges;
      //             groupTicketDetailsProperties.totalbaggageCharges += this.groupTicketReturnSegmentsProperties[d].baggageCharges;
      //         }
      //     }
      //     this.groupTicketDetailsProperties.push(groupTicketDetailsProperties);
      // }
      // else {
      //     for (let t = 0; t < this.groupTicketDetailsProperties.length; t++) {
      //         this.groupTicketDetailsProperties[t].totalMealCharges = 0;
      //         this.groupTicketDetailsProperties[t].totalSeatCharges = 0;
      //         this.groupTicketDetailsProperties[t].totalbaggageCharges = 0;
      //         for (let d = 0; d < this.groupTicketDepartureSegmentsProperties.length; d++) {
      //             this.groupTicketDetailsProperties[t].totalMealCharges += this.groupTicketDepartureSegmentsProperties[d].mealCharges;
      //             this.groupTicketDetailsProperties[t].totalSeatCharges += this.groupTicketDepartureSegmentsProperties[d].seatCharges;
      //             this.groupTicketDetailsProperties[t].totalbaggageCharges += this.groupTicketDepartureSegmentsProperties[d].baggageCharges;

      //         }
      //         if (this.returnTicketSections == true) {
      //             for (let r = 0; r < this.groupTicketReturnSegmentsProperties.length; r++) {
      //                 this.groupTicketDetailsProperties[t].totalMealCharges += this.groupTicketReturnSegmentsProperties[r].mealCharges;
      //                 this.groupTicketDetailsProperties[t].totalSeatCharges += this.groupTicketReturnSegmentsProperties[r].seatCharges;
      //                 this.groupTicketDetailsProperties[t].totalbaggageCharges += this.groupTicketReturnSegmentsProperties[r].baggageCharges;

      //             }
      //         }
      //         this.groupTicketDetailsProperties[t].totalPrices = this.groupTicketDetailsProperties[t].baseFare
      //             + this.groupTicketDetailsProperties[t].taxesAndOtherCharges + this.groupTicketDetailsProperties[t].totalMealCharges
      //             + this.groupTicketDetailsProperties[t].totalSeatCharges + this.groupTicketDetailsProperties[t].totalbaggageCharges;
      //     }

      // }

      //  }
    }
  }
  SetBackTicketStart = (): void => {
    this.showTicketDetailsSection1 = true;
    this.showSegmentDetailsSection = false;
  }
  AddNewPassengerDetail = (): void => {
    if (this.groupTicketDetailsProperties.length < 3) {
      let groupTicketDetailsProperties = new GroupTicketDetailsProperties();
      this.groupTicketDetailsProperties.push(groupTicketDetailsProperties);
    }
    else {
      document.getElementById(`passengerTitle`).innerHTML = "Only Three Passengers Allowed!";
      document.getElementById(`passengerTitle`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`passengerTitle`).innerHTML = "Passenger Detail";
        document.getElementById(`passengerTitle`).style.color = "var(--first-color-second)";
      }, 4000)
    }
  }
  RemovePassengerInformation = (index: number): void => {

    if (this.groupTicketDetailsProperties.length > 1) {
      if (this.groupTicketDetailsProperties[index].detailsId != 0) {
        this.ticketService.DeletePassenger(this.groupTicketDetailsProperties[index].detailsId).subscribe((response) => {
          if (response.status == true) {
            document.getElementById(`InformationTitlePassenger${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitlePassenger${index}`).style.color = "#2BA744";
            setTimeout(() => {
              this.groupTicketDetailsProperties.splice(index, 1);
            }, 4000)

          }
          else {
            document.getElementById(`InformationTitlePassenger${index}`).innerHTML = response.message;
            document.getElementById(`InformationTitlePassenger${index}`).style.color = "#f44336";
            setTimeout(() => {
              document.getElementById(`InformationTitlePassenger${index}`).innerHTML = "Segment Information: <b>1</b>";
              document.getElementById(`InformationTitlePassenger${index}`).style.color = "";
            }, 4000)

          }
        }, (error) => {
          document.getElementById(`InformationTitlePassenger${index}`).innerHTML = error;
          document.getElementById(`InformationTitlePassenger${index}`).style.color = "#f44336";
          setTimeout(() => {
            document.getElementById(`InformationTitlePassenger${index}`).innerHTML = "Segment Information: <b>1</b>";
            document.getElementById(`InformationTitlePassenger${index}`).style.color = "";
          }, 5000)
        });
      }
      else {
        this.groupTicketDetailsProperties.splice(index, 1);
      }
    }
    else {
      document.getElementById(`InformationTitlePassenger${0}`).innerHTML = "Not Allowed to Remove All Passenger!";
      document.getElementById(`InformationTitlePassenger${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitlePassenger${0}`).innerHTML = "Passenger Information: <b>1</b>";
        document.getElementById(`InformationTitlePassenger${0}`).style.color = "";
      }, 4000)
    }
  }
  PassengerTotalPrice = (index: number): void => {
    if (this.groupTicketDetailsProperties[index].serviceCharges < 0 || this.groupTicketDetailsProperties[index].serviceCharges == null) {
      this.groupTicketDetailsProperties[index].serviceCharges = 0;
    }
    if (this.groupTicketDetailsProperties[index].markup < 0 || this.groupTicketDetailsProperties[index].markup == null) {
      this.groupTicketDetailsProperties[index].markup = 0;
    }
    if (this.groupTicketDetailsProperties[index].totalMealCharges < 0 || this.groupTicketDetailsProperties[index].totalMealCharges == null) {
      this.groupTicketDetailsProperties[index].totalMealCharges = 0;
    }
    if (this.groupTicketDetailsProperties[index].totalSeatCharges < 0 || this.groupTicketDetailsProperties[index].totalSeatCharges == null) {
      this.groupTicketDetailsProperties[index].totalSeatCharges = 0;
    }
    if (this.groupTicketDetailsProperties[index].totalbaggageCharges < 0 || this.groupTicketDetailsProperties[index].totalbaggageCharges == null) {
      this.groupTicketDetailsProperties[index].totalbaggageCharges = 0;
    }
    if (this.groupTicketDetailsProperties[index].changeFee < 0 || this.groupTicketDetailsProperties[index].changeFee == null) {
      this.groupTicketDetailsProperties[index].changeFee = 0;
    }
    if (this.groupTicketDetailsProperties[index].cancel_RefundFee < 0 || this.groupTicketDetailsProperties[index].cancel_RefundFee == null) {
      this.groupTicketDetailsProperties[index].cancel_RefundFee = 0;
    }
    if (this.groupTicketDetailsProperties[index].baseFare >= 0 && this.groupTicketDetailsProperties[index].taxesAndOtherCharges >= 0) {
      this.groupTicketDetailsProperties[index].totalNetPrice = this.groupTicketDetailsProperties[index].baseFare
        + this.groupTicketDetailsProperties[index].taxesAndOtherCharges + this.groupTicketDetailsProperties[index].totalMealCharges
        + this.groupTicketDetailsProperties[index].totalSeatCharges + this.groupTicketDetailsProperties[index].totalbaggageCharges;
      this.groupTicketDetailsProperties[index].totalGrossPrice = this.groupTicketDetailsProperties[index].baseFare
        + this.groupTicketDetailsProperties[index].taxesAndOtherCharges + this.groupTicketDetailsProperties[index].totalMealCharges
        + this.groupTicketDetailsProperties[index].totalSeatCharges + this.groupTicketDetailsProperties[index].totalbaggageCharges
        + this.groupTicketDetailsProperties[index].serviceCharges + this.groupTicketDetailsProperties[index].markup;
    }
  }
  SubmitPassengerDetail = (passengerForm: any): boolean => {

    let passengerValidationSuccess = true;
    this.passengerSubmitted = true;
    if (passengerForm.invalid) {
      document.getElementById("errorPassengerSection").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorPassengerSection").innerHTML = "";
      }, 5000);
      return false;
    }
    else {
      for (let pd = 0; pd < this.groupTicketDetailsProperties.length; pd++) {

        if (this.groupTicketDetailsProperties[pd].baseFare <= 0) {
          passengerValidationSuccess = false;
          document.getElementById("errorPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById("errorPassengerSection").innerHTML = "";
          }, 5000);
          return false;
        }
        if (this.groupTicketDetailsProperties[pd].taxesAndOtherCharges <= 0) {
          passengerValidationSuccess = false;
          document.getElementById("errorPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById("errorPassengerSection").innerHTML = "";
          }, 5000);
          return false;
        }
        if (this.groupTicketDetailsProperties[pd].cancel_RefundFee < 0 || this.groupTicketDetailsProperties[pd].cancel_RefundFee == null) {
          this.groupTicketDetailsProperties[pd].cancel_RefundFee = 0
        }
        if (this.groupTicketDetailsProperties[pd].changeFee < 0 || this.groupTicketDetailsProperties[pd].changeFee == null) {
          this.groupTicketDetailsProperties[pd].changeFee = 0
        }
      }
      if (passengerValidationSuccess == true) {
        this.groupTicketProperties.totalBaseFare = 0;
        this.groupTicketProperties.totalTaxesAndOtherCharges = 0;
        this.groupTicketProperties.totalNetPrice = 0;
        this.groupTicketProperties.totalGrossPrice = 0;
        this.groupTicketProperties.isAdult = false;
        this.groupTicketProperties.isChild = false;
        this.groupTicketProperties.isInfant = false;
        this.groupTicketProperties.groupTicketSegmentsProperties = [];
        for (let i = 0; i < this.groupTicketDetailsProperties.length; i++) {
          this.groupTicketProperties.totalBaseFare += this.groupTicketDetailsProperties[i].baseFare;
          this.groupTicketProperties.totalTaxesAndOtherCharges += this.groupTicketDetailsProperties[i].taxesAndOtherCharges;
          this.groupTicketProperties.totalNetPrice += this.groupTicketDetailsProperties[i].totalNetPrice;
          this.groupTicketProperties.totalGrossPrice += this.groupTicketDetailsProperties[i].totalGrossPrice;
          if (this.groupTicketDetailsProperties[i].passengerType == 1) {
            this.groupTicketProperties.isAdult = true;
          }
          if (this.groupTicketDetailsProperties[i].passengerType == 2) {
            this.groupTicketProperties.isChild = true;
          }
          if (this.groupTicketDetailsProperties[i].passengerType == 3) {
            this.groupTicketProperties.isInfant = true;
          }
        }
        // if (this.groupTicketDepartureSegmentsProperties[0].segmentType == 1) {
        //     this.groupTicketProperties.tripType = "OneWay";
        // }
        // else {
        //     this.groupTicketProperties.tripType = "Return";
        // }
        //this.groupTicketProperties.departureDate = this.groupTicketDepartureSegmentsProperties[0].departureDate;
        this.groupTicketProperties.groupTicketDetailsProperties = this.groupTicketDetailsProperties;
        for (let d = 0; d < this.groupTicketDepartureSegmentsProperties.length; d++) {
          this.groupTicketProperties.groupTicketSegmentsProperties.push(this.groupTicketDepartureSegmentsProperties[d]);
        }
        if (this.returnTicketSections == true) {
          // this.groupTicketProperties.returnDate = this.groupTicketReturnSegmentsProperties[0].departureDate;
          for (let rs = 0; rs < this.groupTicketReturnSegmentsProperties.length; rs++) {
            this.groupTicketProperties.groupTicketSegmentsProperties.push(this.groupTicketReturnSegmentsProperties[rs]);
          }

        }
        // else {
        //     this.groupTicketProperties.returnDate ;
        // }
        // console.log(this.groupTicketProperties.groupTicketSegmentsProperties);
        this.showTicketDetailsSection2 = true;
        this.showPassengerDetailsSection = false;

      }
    }
  }
  SetBackToSegment = (): void => {
    this.groupTicketProperties.groupTicketSegmentsProperties = [];
    this.showSegmentDetailsSection = true;
    this.showPassengerDetailsSection = false;
  }
  SubmitTicket = (finalTicketDetail: any): boolean => {
    let ticketSubmittedValid = true;
    this.ticketSubmittedSection2 = true;
    if (finalTicketDetail.invalid) {
      document.getElementById("responseMeaasge").innerHTML = "**Please Enter Required Filelds!";
      document.getElementById("responseMeaasge").style.color = "#f44336";
      setTimeout(() => {
        document.getElementById("responseMeaasge").innerHTML = "";
        document.getElementById("responseMeaasge").style.color = "";
      }, 5000);
      return;
    }
    else {


      if (this.groupTicketProperties.fareRulesDetails.trim() == "") {
        ticketSubmittedValid = false;
        return false;
      }
      else {
        this.groupTicketProperties.fareRulesDetails = this.groupTicketProperties.fareRulesDetails.trim();
      }
      if (this.groupTicketProperties.generalRules.trim() == "") {
        ticketSubmittedValid = false;
        return false;
      }
      else {
        this.groupTicketProperties.generalRules = this.groupTicketProperties.generalRules.trim();
      }
      if (this.groupTicketProperties.supplierRemarks.trim() == "") {
        ticketSubmittedValid = false;
        return false;
      }
      else {
        this.groupTicketProperties.supplierRemarks = this.groupTicketProperties.supplierRemarks.trim();
      }
      if (this.groupTicketProperties.totalNumberTicket > this.numberTicketsTotal) {
        if (this.numberTicketsTotal > 0) {
          let remaining: number = 0;
          remaining = this.groupTicketProperties.totalNumberTicket - this.numberTicketsTotal;
          this.groupTicketProperties.remainingTickets += remaining;
        }
        else {
          this.groupTicketProperties.remainingTickets = this.groupTicketProperties.totalNumberTicket;
        }
      }
      if (ticketSubmittedValid == true) {
        this.buttonDisabled = true;
        this.loaderVar = true;
        this.ticketService.SaveUpdateGroupTicket(this.groupTicketProperties).subscribe((response) => {
          if (response.status == true) {
            this.loaderVar = false;
            this.GetAllGroupTicket();
            document.getElementById("responseMeaasge").innerHTML = response.message;
            document.getElementById("responseMeaasge").style.color = "#2BA744";
            setTimeout(() => {
              document.getElementById("responseMeaasge").innerHTML = "";
              document.getElementById("responseMeaasge").style.color = "";

              this.buttonDisabled = false;
              this.CloseTicketSection();
            }, 5000);
          }
          else {
            this.loaderVar = false;
            this.buttonDisabled = false;
            document.getElementById("responseMeaasge").innerHTML = response.message;
            document.getElementById("responseMeaasge").style.color = "#f44336";
            setTimeout(() => {
              document.getElementById("responseMeaasge").innerHTML = "";
              document.getElementById("responseMeaasge").style.color = "";
            }, 5000);

          }

        }, (error) => {
          this.loaderVar = false;
          setTimeout(() => {
            this.buttonDisabled = false;
          }, 500);
          document.getElementById("responseMeaasge").innerHTML = error;
          document.getElementById("responseMeaasge").style.color = "#f44336";
          setTimeout(() => {
            document.getElementById("responseMeaasge").innerHTML = "";
            document.getElementById("responseMeaasge").style.color = "";
          }, 5000);

        });
      }

      // if (passengerValidationSuccess == true) {
      //     this.showFareRulesDetailsSection = true;
      //     this.showPassengerDetailsSection = false;

      // }
    }
  }
  SetBackToPassengerDetails = (): void => {
    this.showPassengerDetailsSection = true;
    this.showTicketDetailsSection2 = false;
  }
  EditTicket = (groupId: number): void => {
    this.ticketService.GetByIdGroupTicket(groupId).subscribe((response) => {
      if (response.status == true) {
        this.submitButtonText = "Update"
        this.groupTicketProperties = response.responseData;
        if (this.groupTicketProperties.supplierCode != "") {
          this.GetSupplierAccessCodes(this.groupTicketProperties.supplierCode);
        }
        this.numberTicketsTotal = this.groupTicketProperties.totalNumberTicket;
        this.groupTicketDetailsProperties = this.groupTicketProperties.groupTicketDetailsProperties;
        for (let s = 0; s < this.groupTicketProperties.groupTicketSegmentsProperties.length; s++) {
          if (this.groupTicketProperties.groupTicketSegmentsProperties[s].departureSegment == true) {
            this.groupTicketProperties.groupTicketSegmentsProperties[s].departureDate = this.groupTicketProperties.groupTicketSegmentsProperties[s].departureDate;
            this.groupTicketProperties.groupTicketSegmentsProperties[s].arrivalDate = this.groupTicketProperties.groupTicketSegmentsProperties[s].arrivalDate;
            this.groupTicketDepartureSegmentsProperties.push(this.groupTicketProperties.groupTicketSegmentsProperties[s]);
          }
          if (this.groupTicketProperties.groupTicketSegmentsProperties[s].returnSegment == true) {
            this.groupTicketProperties.groupTicketSegmentsProperties[s].departureDate = this.groupTicketProperties.groupTicketSegmentsProperties[s].departureDate;
            this.groupTicketProperties.groupTicketSegmentsProperties[s].arrivalDate = this.groupTicketProperties.groupTicketSegmentsProperties[s].arrivalDate;
            this.groupTicketReturnSegmentsProperties.push(this.groupTicketProperties.groupTicketSegmentsProperties[s]);
          }

        }
        if (this.groupTicketProperties.tripType.includes("OneWay")) {
          this.ticketTitle = "Ticket Detail - One Way";
          this.showTicketDetailsSection1 = true;
          this.oneWayTicketSections = true;
          this.showAddTicketSections = false;
        }
        else {
          this.ticketTitle = "Ticket Detail - Return";
          this.showTicketDetailsSection1 = true;
          this.oneWayTicketSections = true;
          this.returnTicketSections = true;
          this.showAddTicketSections = false;
        }
      }
      else {
        this.ticketTitleHead = response.message;
        document.getElementById("ticket_TitleHead").style.color = "#f44336";
        setTimeout(() => {
          this.ticketTitleHead = "Click To Add Ticket";
          document.getElementById("ticket_TitleHead").style.color = "black";
        }, 5000)

      }
    }, (error) => {
      this.ticketTitleHead = error;
      document.getElementById("ticket_TitleHead").style.color = "#f44336";
      setTimeout(() => {
        this.ticketTitleHead = "Click To Add Ticket";
        document.getElementById("ticket_TitleHead").style.color = "black";
      }, 5000)
    });

  }
  DeleteTicket = (groupId: number): void => {
    this.ticketService.DeleteGroupTicket(groupId).subscribe((response) => {
      if (response.status == true) {
        this.ticketTitleHead = response.message;
        document.getElementById("ticket_TitleHead").style.color = "#2BA744";

        this.GetAllGroupTicket();
        setTimeout(() => {
          this.ticketTitleHead = "Click To Add Ticket";
          document.getElementById("ticket_TitleHead").style.color = "black";
        }, 5000)

      }
      else {
        this.ticketTitleHead = response.message;
        document.getElementById("ticket_TitleHead").style.color = "#f44336";
        setTimeout(() => {
          this.ticketTitleHead = "Click To Add Ticket";
          document.getElementById("ticket_TitleHead").style.color = "black";
        }, 5000)

      }
    }, (error) => {
      this.ticketTitleHead = error;
      document.getElementById("ticket_TitleHead").style.color = "#f44336";
      setTimeout(() => {
        this.ticketTitleHead = "Click To Add Ticket";
        document.getElementById("ticket_TitleHead").style.color = "black";
      }, 5000)
    });

  }
  passengerDetailsOpen: boolean = false;
  PassengerDetailsList: BookingPassengerInfo[] = [];


  PassengerDetailsClose() {
    this.passengerDetailsOpen = false;
    this.showAddTicketSections = true;
    this.PassengerDetailsList = [];
  }

  visiblePaxDialog: boolean = false;
  TicketDetailsClick(groupTicketId: number) {

    //console.log("the function TicketDetailsClick has been triggered. GroupId: " + groupTicketId);
    this.visiblePaxDialog = true;
    //this.passengerDetailsOpen = true;
    //this.showAddTicketSections = false;
    let uniqueIdForTEst: number = 1;

    this.ticketService.GetGroupTicketPassengerDetails(groupTicketId).subscribe((data) => {

      this.PassengerDetailsList = data;

    });
  }
  TicketManageClick(bookingID: bigint) {
    localStorage.setItem('bookingID', String(bookingID));
    localStorage.setItem("fromroutePageNoright", "BookingPage");
    this.router.navigateByUrl('/ticket-issuance');
  }
}
